export const LANGUAGES = {
  en: {
    label: 'United States – English',
    prefix: '',
    drupalLangcode: 'en',
    languageSwitcher: true,
  },
  'en-ca': {
    label: 'Canada – English',
    prefix: '/en-ca',
    drupalLangcode: 'en-ca',
    languageSwitcher: true,
  },
  'fr-ca': {
    label: 'Canada – Français',
    prefix: '/fr-ca',
    drupalLangcode: 'fr-ca',
    languageSwitcher: true,
  },
  'de-de': {
    label: 'Deutschland - Deutsch',
    prefix: '/de-de',
    drupalLangcode: 'de-de',
    languageSwitcher:
      process.env.GATSBY_LOCALIZATION_ENABLED === 'false' ? false : true,
  },
  'nl-nl': {
    label: 'Nederland - Nederlands',
    prefix: '/nl-nl',
    drupalLangcode: 'nl-nl',
    languageSwitcher:
      process.env.GATSBY_LOCALIZATION_ENABLED === 'false' ? false : true,
  },
  'en-eu': {
    label: 'Europe – English',
    prefix: '/en-eu',
    drupalLangcode: 'en-eu',
    languageSwitcher:
      process.env.GATSBY_LOCALIZATION_ENABLED === 'false' ? false : true,
  },
  ar: {
    label: 'المملكة العربية السعودية – العربية',
    prefix: '/ar',
    drupalLangcode: 'ar',
    languageSwitcher: true,
  },
  zh: {
    label: '简体中文',
    prefix: '/zh',
    drupalLangcode: 'zh-hans',
    languageSwitcher: false,
  },
};

// list given by Stephen Johnston (Annya's team), via Teams chat on 2021-08-10
const codes = [
  'ar-SA',
  'ar-AE',
  'ca-ES',
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'de-LU',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-HK',
  'en-IE',
  'en-NZ',
  'en-SA',
  'en-US',
  'es-LA',
  'es-ES',
  'es-MX',
  'es-US',
  'eu-ES',
  'fi-FI',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'fr-LU',
  'fr-MC',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'hu-HU',
  'id-ID',
  'it-CH',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'lb-LU',
  'ms-MY',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'sv-FI',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'zh-CN',
  'zh-HK',
  'zh-SG',
  'zh-TW',
];

const setLanguage = locale => {
  let l = '';
  if (locale?.length > 0) {
    l = locale.slice(0, 2);
    return l;
  } else {
    return locale;
  }
};

// Locales supported by Gigya https://console.gigya.com/
export const getGigyaLocale = LucidLocale => {
  let GigyaLocale;
  switch (LucidLocale) {
    case 'en':
      GigyaLocale = 'en';
      break;
    case 'en-ca':
      GigyaLocale = 'en-ca';
      break;
    case 'fr-ca':
      GigyaLocale = 'fr-ca';
      break;
    case 'de-de':
      GigyaLocale = 'de';
      break;
    case 'nl-nl':
      GigyaLocale = 'nl';
      break;
    case 'de-ch':
      GigyaLocale = 'de';
      break;
    case 'fr-ch':
      GigyaLocale = 'fr';
      break;
    case 'nb-no':
      GigyaLocale = 'no';
      break;
    case 'en-eu':
      GigyaLocale = 'en';
      break;
    case 'ar':
      GigyaLocale = 'ar';
      break;
    case 'ar-sa':
      GigyaLocale = 'ar';
      break;
    case 'zh':
      GigyaLocale = 'zh-cn';
      break;
    default:
      GigyaLocale = 'en';
  }
  return GigyaLocale;
};

export const localeAvailable = locale => {
  if (LANGUAGES[locale] && LANGUAGES[locale].languageSwitcher == true) {
    return locale;
  }
  return false;
};

export const enabledLocales = () => {
  const locales = [];
  Object.values(LANGUAGES).map(locale => {
    if (locale.languageSwitcher == true) locales.push(locale.drupalLangcode);
  });
  return locales;
};

const localeHierarchy = locale => {
  const l = setLanguage(locale);
  // ex: hierarchy = ['fr-ca']
  const hierarchy = [locale.toLowerCase()];

  // add all available locales of the same language (in order of `codes` array)
  // ex: hierarchy = ['fr-ca', 'fr-be', 'fr-ch', 'fr-fr', 'fr-lu', 'fr-mc']
  for (let z = 0; z < codes.length; z++) {
    const thisLocale = codes[z];
    const thisLocaleL = setLanguage(thisLocale);
    const sameLanguage = thisLocaleL == l;
    const sameLocale = thisLocale.toLowerCase() == locale.toLowerCase();
    if (sameLanguage && !sameLocale) hierarchy.push(codes[z].toLowerCase());
  }

  // add language-only
  // ex: hierarchy = ['fr-ca', 'fr-be', 'fr-ch', 'fr-fr', 'fr-lu', 'fr-mc', 'fr']
  hierarchy.push(l);

  // if hierarchy does not already include them, add 'en-us' and 'en'
  // ex: hierarchy = ['fr-ca', 'fr-be', 'fr-ch', 'fr-fr', 'fr-lu', 'fr-mc', 'fr', 'en-us', 'en']
  if (hierarchy.indexOf('en-us') < 0) hierarchy.push('en-us');
  if (hierarchy.indexOf('en') < 0) hierarchy.push('en');

  // ex: hierarchy = ['fr-ca', 'fr-be', 'fr-ch', 'fr-fr', 'fr-lu', 'fr-mc', 'fr', 'en-us', 'en']
  return hierarchy;
};
const getContentFromLocale = (content, locale) => {
  const hierarchy = localeHierarchy(locale);

  for (let z = 0; z < hierarchy.length; z++) {
    if (localeAvailable(hierarchy[z]) && content[hierarchy[z]]) {
      locale = hierarchy[z];
      break;
    }
  }

  return content[locale];
};
const getNodesFromLocale = (nodeFilter, locale) => {
  const hierarchy = localeHierarchy(locale);

  for (let z = 0; z < hierarchy.length; z++) {
    if (
      localeAvailable(hierarchy[z]) &&
      nodeFilter(hierarchy[z]) &&
      nodeFilter(hierarchy[z]).length > 0
    ) {
      locale = hierarchy[z];
      break;
    }
  }

  return nodeFilter(locale);
};

export function getLanguagePrefix(lng) {
  return (LANGUAGES[lng] && LANGUAGES[lng].prefix) || '';
}

export function getLangcodeFromDrupalLangcode(drupalLangcode) {
  return Object.entries(LANGUAGES).find(
    entry => entry[1].drupalLangcode === drupalLangcode
  )[0];
}

export function getLocalizedPathToPage(node) {
  return node.path && node.path.alias
    ? node.path.alias
    : `${getLanguagePrefix(node.langcode)}/node/${node.drupal_internal__nid}`;
}

export function removeLocalizationFromPath(path) {
  const locales = enabledLocales();
  locales.forEach(l => (path = path.replace(`/${l}/`, '/')));
  return path;
}

export function getLocalizedContent(content, language) {
  const lng = language || 'en';
  return getContentFromLocale(content, lng);
}

export function filterNodesByLanguage(nodes, langcode) {
  const nodeFilter = l => nodes.filter(node => node.langcode == l);
  return getNodesFromLocale(nodeFilter, langcode);
}

export function findNodeByLanguage(nodes, langcode) {
  const nodeFilter = l => nodes.filter(node => node.langcode == l);
  return getNodesFromLocale(nodeFilter, langcode)[0];
}

export function filterNodesByLangcode(nodes, langcode) {
  const nodeFilter = l => nodes.filter(node => node.langcode === l);
  return getNodesFromLocale(nodeFilter, langcode);
}

export function getLocalizedNodes(nodes, langcode) {
  return filterNodesByLanguage(nodes, langcode);
}

export function handleChangeLng(newLng, lng) {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname.replace(
      `${LANGUAGES[lng].prefix}/`,
      '/'
    );
    window.location.href =
      window.location.origin + LANGUAGES[newLng].prefix + path;
  }
}
